import { render } from "./StaffEmployeeDetail.vue?vue&type=template&id=72733335&scoped=true"
import script from "./StaffEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./StaffEmployeeDetail.vue?vue&type=script&lang=js"

import "./StaffEmployeeDetail.vue?vue&type=style&index=0&id=72733335&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72733335"],['__file',"src/views/qywx/common/sys/StaffEmployeeDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72733335"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72733335', __exports__)) {
    api.reload('72733335', __exports__)
  }
  
  module.hot.accept("./StaffEmployeeDetail.vue?vue&type=template&id=72733335&scoped=true", () => {
    api.rerender('72733335', render)
  })

}


export default __exports__